// extracted by mini-css-extract-plugin
export default {"textArea":"EmbedCode-textArea-9417c7df1242733fb25beea589575695","copyArea":"EmbedCode-copyArea-84880b9fbb7ad25d18899a8d745f4a05"};